import { isExpiredTrialWithNoPlan as isLegacyExpiredTrialWithNoPlan } from '../internal/legacySubscription/isExpiredTrialWithNoPlan';
import { isExpiredTrialWithNoPlan as isModernExpiredTrialWithNoPlan } from '../internal/modernSubscription/isExpiredTrialWithNoPlan';
import type { Subscription } from '../types';

import { isModernSubscription } from './isModernSubscription';

export function isExpiredTrialWithNoPlan(subscription: Subscription) {
  if (isModernSubscription(subscription)) {
    return isModernExpiredTrialWithNoPlan(subscription);
  }

  return isLegacyExpiredTrialWithNoPlan(subscription);
}
